var _mask, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnnouncement = function SvgAnnouncement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "announcement_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 10.4,
    x: 0.8,
    y: 4,
    rx: 0.8
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 10.4,
    x: 0.8,
    y: 4,
    stroke: "#1A1A1A",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#announcement_svg__a)",
    rx: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 7.2h8M4 9.6h4M3 4.5 8 2l5 2.5"
  })));
};
export default SvgAnnouncement;